<template>
	<div class="detail_wrap">
		<div class="wrap_content">
			<div class="wrap_bread">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item @click.native="commonHandle('templateCenter')">
						模板中心
					</el-breadcrumb-item>
					<el-breadcrumb-item @click.native="commonHandle('typeName')">
						{{ currentTemplate.type_name }}
					</el-breadcrumb-item>
					<el-breadcrumb-item>{{ currentTemplate.name }}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="content_main">
				<div class="main_left">
					<img :src="currentTemplate.cover_url" alt="" />
				</div>
				<div class="main_right">
					<div class="right_top">
						<div class="top_header">
							<div class="header_title">{{ currentTemplate.name }}</div>
							<div
								:class="`header_collect iconfont icon-collected ${
									currentTemplate.is_collect
										? 'icon-collection'
										: 'icon-uncollection'
								}`"
								@click="collect(currentTemplate)"
							>
								<span>{{ currentTemplate.is_collect ? '已收藏' : '收藏' }}</span>
							</div>
						</div>
						<div class="top_btn" @click.self="goDesign(currentTemplate)">立即使用</div>
					</div>
					<div class="line"></div>
					<div class="right_main">
						<p>
							爱设计作图提供海量精美设计模板《{{ currentTemplate.name }}》适用于{{
								currentTemplate.type_name
							}}，点击立即使用，通过拖，拉，拽迅速出图。
						</p>
						<p>
							《{{ currentTemplate.name }}》设计风格为{{
								currentTemplate.style_name
							}}，适用于用途{{ currentTemplate.industry_name }}，主要配色为{{
								currentTemplate.color_name
							}}。编辑完成点击下载，立即得到您满意的配图。
						</p>
					</div>
					<div class="right_footer">
						<div
							class="tag_item"
							v-for="(item, index) in tags"
							:key="index"
							@click="commonHandle('search', item)"
						>
							{{ item }}
						</div>
					</div>
				</div>
			</div>
			<div class="middle">
				<div class="middle_title">推荐模板</div>
				<div class="middle_main">
					<div class="tag_wrapper">
						<!-- todo -->
						<div
							class="tag_item"
							data-id="67156"
							data-type="5"
							v-for="item in recommendList"
							:key="item.id"
							@click="goDesign(item)"
						>
							<div class="item_inner">
								<img class="temp_img" :src="item.cover_url" :alt="item.name" />

								<div class="jbalert-box">
									<div class="tag_preview_btn">
										<span
											class="iconfont icon-preview1"
											@click.stop="preview(item)"
										></span>
									</div>
									<div
										:class="`tag_collect_btn iconfont icon-collected ${
											item.is_collect
												? 'icon-collection'
												: 'icon-uncollection'
										}`"
										@click.stop="collect(item)"
									></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { TemplateCenter } from '@/config/axios/new_api'

export default {
	data() {
		return {
			currentTemplate: {}, // 当前模板信息
			tags: [], // 关键词
			recommendList: [], // 推荐列表
		}
	},
	created() {
		this.getTemplateDetail()
		this.recommend()
	},
	methods: {
		// 获取详情
		async getTemplateDetail() {
			let res = await TemplateCenter.templateDetail({
				template_id: this.staticFunc.GetQueryString('templateId'),
				type: this.staticFunc.GetQueryString('type'),
			})
			if (res.status == 1) {
				this.currentTemplate = res.data
				this.tags = res.data.keyword.trim().split(' ')
			}
		},
		// 收藏模板
		async collect(info) {
			if (info.is_collect) {
				let res = await TemplateCenter.uncollect({
					designer_template_id: info.id,
				})
				if (res.status == 1) {
					this.$message.success('取消收藏成功')
				}
			} else {
				let res = await TemplateCenter.collect({
					designer_template_id: info.id,
				})
				if (res.status == 1) {
					this.$message.success('收藏成功')
				}
			}
			this.getTemplateDetail()
			this.recommend()
		},
		// 预览模板
		preview(val) {
			window.open(`/templateCenterDetail?templateId=${val.id}&type=${val.type}`, '_blank')
		},
		// 推荐模板列表
		async recommend() {
			let params = {
				template_id: this.staticFunc.GetQueryString('templateId'),
				type: this.staticFunc.GetQueryString('type'),
			}
			let res = await TemplateCenter.recommend(params)
			this.recommendList = res.data
		},
		goDesign(item) {
			this.goDesignworkbench(item, item.id, 'templatecenter')
		},
		commonHandle(type, value) {
			let params = {
				page: 1,
				page_size: 50,
				industry_id: 0, // 用途id
				style_id: 0, // 风格id
				sort: 'asc', // 排序 asc或desc
				keyword: '', // 搜索词
				classify: 0, // 分类id
				scene_id: 0, //	场景id
				order: 5, // 排序字段 [最多使用:2  最新上传:4  综合排序:5
			}
			if (type === 'search') {
				params.keyword = value
			} else if (type === 'typeName') {
				params.scene_id = this.currentTemplate.type
			}
			localStorage.setItem('templateParams', JSON.stringify(params))
			this.$router.push('/templateCenter')
		},
	},
}
</script>

<style lang="scss" scoped>
.detail_wrap {
	min-height: calc(100vh - 60px);
	box-sizing: border-box;
	background-color: #f9f9fc;
}
.wrap_content {
	width: 1166px;
	min-height: 100%;
	box-sizing: border-box;
	margin: 0 auto;
}
.wrap_bread {
	margin-top: 30px;
	width: auto;
	::v-deep( .el-breadcrumb) {
		height: 22px;
		font-size: 16px;
		font-family: PingFang-SC-Regular;
		font-weight: 400;
		color: #333333;
		line-height: 22px;
		margin-bottom: 16px;
		.el-breadcrumb__item {
			.el-breadcrumb__inner {
				color: #333333;
				cursor: pointer;
			}
			.el-breadcrumb__separator {
				color: #333333;
				margin: 0 3px;
			}
		}
	}
}
.content_main {
	width: 100%;
	margin-bottom: 50px;
	display: flex;
	.main_left {
		width: 760px;
		height: 600px;
		background: #fff;
		margin-right: 26px;
		box-sizing: border-box;
		padding: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			max-width: 100%;
			max-height: 100%;
		}
	}
	.main_right {
		width: 380px;
		background: white;
		box-sizing: border-box;
		padding: 20px 20px 16px 20px;
		.right_top {
			.top_header {
				width: 100%;
				max-height: 56px;
				margin-bottom: 20px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				position: relative;
				.header_title {
					width: 250px;
					height: 100%;
					overflow: hidden;
					font-size: 20px;
					font-weight: 600;
					color: #333;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				}
				.header_collect {
					width: 52px;
					cursor: pointer;
					user-select: none;
					display: flex;
					align-items: center;
					span {
						margin-top: -3px;
						color: #333;
						font-size: 10px;
					}
				}
			}
			.top_btn {
				width: 340px;
				height: 40px;
				line-height: 40px;
				text-align: center;
				cursor: pointer;
				box-sizing: border-box;
				border-radius: 20px;
				background: #7966ff;
				border: none;
				color: white;
				margin-bottom: 30px;
			}
		}
		.line {
			width: 100%;
			box-sizing: border-box;
			border-top: 1px solid #eaeaea;
			margin-bottom: 28px;
		}
		.right_main {
			width: 100%;
			margin-bottom: 50px;
			p {
				height: 66px;
				font-size: 14px;
				font-family: PingFang-SC-Regular;
				font-weight: 400;
				color: #666;
				line-height: 22px;
				margin-bottom: 16px;
				&:last-child {
					margin-bottom: 0;
				}
			}
		}
		.right_footer {
			width: 100%;
			display: flex;
			align-items: flex-start;
			flex-wrap: wrap;
			.tag_item {
				height: 28px;
				margin-bottom: 14px;
				margin-right: 14px;
				cursor: pointer;
				background: #f7f7f7;
				border-radius: 14px;
				font-size: 14px;
				font-family: PingFang-SC-Regular;
				font-weight: 400;
				color: #666;
				line-height: 28px;
				box-sizing: border-box;
				padding: 0 20px;
			}
		}
	}
	&::before {
		content: '';
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
	}
}
.middle {
	width: 100%;
	padding-bottom: 107px px;
	.middle_title {
		height: 28px;
		font-size: 20px;
		font-family: PingFangSC-Semibold;
		font-weight: 600;
		color: #333;
		line-height: 28px;
		margin-bottom: 8px;
		padding-left: 10px;
	}
	.middle_main {
		width: 100%;
		.tag_wrapper {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			.tag_item {
				width: 233px;
				background: #f9f9fc;
				border-radius: 4px;
				box-sizing: border-box;
				padding: 10px;
				&:hover {
					.item_inner {
						.jbalert-box {
							.tag_preview_btn,
							.tag_collect_btn {
								visibility: visible;
							}
						}
					}
				}
				.item_inner {
					width: 217px;
					position: relative;
					overflow: hidden;
					border-radius: 4px;
					cursor: pointer;
					min-height: 116px;
					display: flex;
					align-items: center;
					background: #fff;
					.temp_img {
						display: block;
						width: 100%;
					}
					.jbalert-box {
						position: absolute;
						left: 0;
						top: 0;
						border-radius: 4px;
						overflow: hidden;
						background: linear-gradient(
							180deg,
							rgba(0, 0, 0, 0.5) 0%,
							transparent 100%
						);
						box-shadow: 0px 2px 10px 0px;
						width: 100%;
						height: 100%;
						opacity: 0;
						.tag_preview_btn {
							visibility: hidden;
							position: absolute;
							top: 10px;
							cursor: pointer;
							text-align: center;
							background: #fff;
							line-height: 28px;
							right: 46px;
							color: #333;
							font-size: 14px;
							width: 30px;
							height: 30px;
							background: #ffffff;
							border-radius: 4px;
							a {
								color: #333;
							}
							.iconfont {
								font-size: 24px;
							}
						}
						.tag_preview_btn:hover {
							background: #e1dfea;
						}
						.tag_collect_btn {
							visibility: hidden;
							position: absolute;
							top: 10px;
							cursor: pointer;
							text-align: center;
							width: 30px;
							height: 30px;
							background: #ffffff;
							border-radius: 4px;
							right: 10px;
							background-color: #fff;
							display: flex;
							justify-content: center;
							align-items: center;
							img {
								display: block;
								width: 16px;
								height: 16px;
								margin: 6px auto;
							}
						}
						.tag_collect_btn:hover {
							background: #e1dfea;
						}
					}
					&:hover {
						.jbalert-box {
							opacity: 1;
							transition: all 0.28s;
						}
					}
				}
			}
		}
	}
}
.icon-collection {
	color: #e54b4b;
}
.icon-uncollection {
	color: #333333;
}
</style>
